import React, { useEffect } from 'react'
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from 'gatsby'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import { ReactLenis } from '@studio-freight/react-lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Header from './header'
import "../styles/styles.scss"
import Footer from "./footer"
import BookingOverlay from "./bookings-overlay"
gsap.registerPlugin(ScrollTrigger);

const Layout = ({children}) => {
    const data = useStaticQuery(graphql`{
        datoCmsSite {
            favicon: faviconMetaTags {
                ...GatsbyDatoCmsFaviconMetaTags
            }
        }
        datoCmsIndex {
            seoMetaTags {
                ...GatsbyDatoCmsSeoMetaTags
            }
        }
    }
    `)
    const metaFavicon = data.datoCmsSite.favicon
    const metaSite = data.datoCmsIndex.seoMetaTags;
    
    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => 
            ScrollTrigger.refresh()
        )
    
        resizeObserver.observe(document.body)
    
        // clean up the observer on unmount
        return () => {
            resizeObserver.disconnect()
        }
    }, []) // the empty dependency array ensures that the observer is only created once

    return (
        <React.Fragment key='layout'>
            <Helmet>
                <html lang="en"/>
                <meta charSet="utf-8" />
                <link rel="stylesheet" href="//onsass.designmynight.com" />
            </Helmet>
            <HelmetDatoCms 
                favicon={metaFavicon}
                seo={metaSite}
            />
            <ReactLenis root options={{
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
                smoothWheel: true,
                wheelMultiplier: 1,
                smoothTouch: false,
                touchMultiplier: 2,
                infinite: false,
            }}>
                <Header />
                {children}
                <Footer />
                <BookingOverlay />
            </ReactLenis>
        </React.Fragment>
    )
}
export default Layout